import { gql } from "@apollo/client";

const schema = {
  assign: {
    name: 'assignMedia',
    serviceName: 'auth',
    query: gql`
      mutation assignMedia($id: String!, $files: [Upload], $model_name: String!, $collection_name: String) {
        assignMedia(id: $id, files: $files, model_name: $model_name, collection_name: $collection_name) {
          messages
        }
      }
    `,
  },
  unassign: {
    name: 'deleteMedia',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteMedia($id: String!, $model_name: String!, $media_ids: [String]) {
        deleteMedia(id: $id, model_name: $model_name, media_ids: $media_ids) {
          messages
        }
      }
    `,
  },
};

export default schema;
